/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Delete_Toast_Error_DescInputs */

const es_sidebar_delete_toast_error_desc = /** @type {(inputs: Sidebar_Delete_Toast_Error_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal al eliminar la conversación.`)
};

const en_sidebar_delete_toast_error_desc = /** @type {(inputs: Sidebar_Delete_Toast_Error_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong while deleting the conversation.`)
};

/**
* | output |
* | --- |
* | "Something went wrong while deleting the conversation." |
*
* @param {Sidebar_Delete_Toast_Error_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_delete_toast_error_desc = /** @type {((inputs?: Sidebar_Delete_Toast_Error_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Delete_Toast_Error_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_delete_toast_error_desc(inputs)
	return en_sidebar_delete_toast_error_desc(inputs)
});
export { sidebar_delete_toast_error_desc as "sidebar.delete_toast.error_desc" }